// extracted by mini-css-extract-plugin
module.exports = {"NumericRangeFeature":"vv_a bhb_b bhb_ux"};